import { useMutation } from '@tanstack/react-query';
import { ObjectiveMediaService } from '@services/objectiveMediaService';

export const useGenerateObjectiveAIMedia = () => {
  return useMutation({
    mutationFn: ({ objective, aiModel }: { objective: string; aiModel: string }) =>
      ObjectiveMediaService.getObjectiveMediaAI({ objective, aiModel }),
  });
};
